const getLabelByHostname = () => {
  const host = window.location.hostname;
  const localizedMessages = {
    '.si': 'Koda kopirana',
    '.hr': 'Kod kopiran',
    '.cz': 'Kód zkopírován',
    '.sk': 'Kód skopírovaný',
    '.pl': 'Skopiowano kod',
    '.hu': 'Kód másolva',
    '.it': 'Codice copiato',
    '.ro': 'Cod copiat',
    '.es': 'Código copiado',
    '.fr': 'Code copié',
    '.de': 'Code kopiert',
    '.nl': 'Code gekopieerd',
    '.gr': 'Ο κωδικός αντιγράφηκε',
    '.lt': 'Kodas nukopijuotas',
    '.lv': 'Kods kopēts',
    '.ee': 'Kood kopeeritud',
    '.bg': 'Кодът е копиран',
    '.ie': 'Code copied',
    '.co.uk': 'Code copied',
    '.com': 'Code copied'
  };

  for (const tld in localizedMessages) {
    if (host.includes(tld)) {
      return localizedMessages[tld];
    }
  }

  return 'Code copied';
};

const code_copied_message = getLabelByHostname();
const copyIconSVG = `
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 115.77 122.88" style="display: inline-flex;max-height: 20px;width: 100%;margin-left: 6px;margin-top: 3px;" xml:space="preserve"><g><path style="fill:white;" class="st0" d="M89.62,13.96v7.73h12.19h0.01v0.02c3.85,0.01,7.34,1.57,9.86,4.1c2.5,2.51,4.06,5.98,4.07,9.82h0.02v0.02 v73.27v0.01h-0.02c-0.01,3.84-1.57,7.33-4.1,9.86c-2.51,2.5-5.98,4.06-9.82,4.07v0.02h-0.02h-61.7H40.1v-0.02 c-3.84-0.01-7.34-1.57-9.86-4.1c-2.5-2.51-4.06-5.98-4.07-9.82h-0.02v-0.02V92.51H13.96h-0.01v-0.02c-3.84-0.01-7.34-1.57-9.86-4.1 c-2.5-2.51-4.06-5.98-4.07-9.82H0v-0.02V13.96v-0.01h0.02c0.01-3.85,1.58-7.34,4.1-9.86c2.51-2.5,5.98-4.06,9.82-4.07V0h0.02h61.7 h0.01v0.02c3.85,0.01,7.34,1.57,9.86,4.1c2.5,2.51,4.06,5.98,4.07,9.82h0.02V13.96L89.62,13.96z M79.04,21.69v-7.73v-0.02h0.02 c0-0.91-0.39-1.75-1.01-2.37c-0.61-0.61-1.46-1-2.37-1v0.02h-0.01h-61.7h-0.02v-0.02c-0.91,0-1.75,0.39-2.37,1.01 c-0.61,0.61-1,1.46-1,2.37h0.02v0.01v64.59v0.02h-0.02c0,0.91,0.39,1.75,1.01,2.37c0.61,0.61,1.46,1,2.37,1v-0.02h0.01h12.19V35.65 v-0.01h0.02c0.01-3.85,1.58-7.34,4.1-9.86c2.51-2.5,5.98-4.06,9.82-4.07v-0.02h0.02H79.04L79.04,21.69z M105.18,108.92V35.65v-0.02 h0.02c0-0.91-0.39-1.75-1.01-2.37c-0.61-0.61-1.46-1-2.37-1v0.02h-0.01h-61.7h-0.02v-0.02c-0.91,0-1.75,0.39-2.37,1.01 c-0.61,0.61-1,1.46-1,2.37h0.02v0.01v73.27v0.02h-0.02c0,0.91,0.39,1.75,1.01,2.37c0.61,0.61,1.46,1,2.37,1v-0.02h0.01h61.7h0.02 v0.02c0.91,0,1.75-0.39,2.37-1.01c0.61-0.61,1-1.46,1-2.37h-0.02V108.92L105.18,108.92z"/></g></svg>`;

const copyElements = document.querySelectorAll('.copy-me');

copyElements.forEach(element => {
  const originalText = element.textContent.trim();
  const textSpan = document.createElement('div');
  textSpan.textContent = originalText;
  textSpan.classList.add("copy-code");
  element.innerHTML = copyIconSVG ; 
  element.appendChild(textSpan);   
  element.addEventListener('click', () => {   
    navigator.clipboard.writeText(originalText).then(() => {
      
      textSpan.textContent = code_copied_message || 'Code copied'; 
      
      setTimeout(() => {
        textSpan.textContent = originalText;
      }, 2000);

    }).catch(err => {
      console.error('Failed to copy text: ', err);
      textSpan.textContent = 'Copy Failed!';        
      setTimeout(() => {
        textSpan.textContent = originalText;
      }, 2000);
    });
  });
});